import PropTypes from "prop-types";
import HorizontalScrollList from "../../HorizontalScrollList";
import CategoryLinksList from "./CategoryLinksList";
import styles from "./CategoryHeaderLinks";

const checkForChildLinks = childLinks => childLinks.length > 0;

const shouldShowSiblingCategories = (hasChildLinks, siblingLinks) =>
  !hasChildLinks && siblingLinks?.length > 1;
const ChildLinks = ({ hasChildLinks, childLinks }) => {
  if (!hasChildLinks) return null;

  return <CategoryLinksList links={childLinks} />;
};

const CombinedSiblingLinks = ({
  shouldShowSiblings,
  siblingLinks,
  relatedLinks
}) => {
  if (!shouldShowSiblings) return null;

  const combinedLinks = [...siblingLinks, ...relatedLinks];

  return <CategoryLinksList links={combinedLinks} />;
};

const CategoryHeaderLinks = ({ childLinks, siblingLinks, relatedLinks }) => {
  const hasChildLinks = checkForChildLinks(childLinks);
  const shouldShowSiblings = shouldShowSiblingCategories(
    hasChildLinks,
    siblingLinks
  );

  if (!hasChildLinks && !shouldShowSiblings && relatedLinks.length === 0) {
    return null;
  }

  return (
    <HorizontalScrollList
      scrollSnapping={false}
      className={styles.categoryHeaderLinks}
    >
      <ChildLinks hasChildLinks={hasChildLinks} childLinks={childLinks} />
      <CombinedSiblingLinks
        shouldShowSiblings={shouldShowSiblings}
        siblingLinks={siblingLinks}
        relatedLinks={relatedLinks}
      />
    </HorizontalScrollList>
  );
};

ChildLinks.propTypes = {
  hasChildLinks: PropTypes.bool.isRequired,
  childLinks: PropTypes.arrayOf(
    PropTypes.shape({
      friendlyName: PropTypes.string.isRequired,
      linkUrl: PropTypes.string.isRequired
    })
  ).isRequired
};
CombinedSiblingLinks.propTypes = {
  shouldShowSiblings: PropTypes.bool.isRequired,
  siblingLinks: PropTypes.arrayOf(
    PropTypes.shape({
      friendlyName: PropTypes.string.isRequired,
      linkUrl: PropTypes.string.isRequired
    })
  ).isRequired,
  relatedLinks: PropTypes.arrayOf(
    PropTypes.shape({
      friendlyName: PropTypes.string.isRequired,
      linkUrl: PropTypes.string.isRequired
    })
  ).isRequired
};
CategoryHeaderLinks.propTypes = {
  childLinks: PropTypes.arrayOf(
    PropTypes.shape({
      friendlyName: PropTypes.string.isRequired,
      linkUrl: PropTypes.string.isRequired
    })
  ).isRequired,
  siblingLinks: PropTypes.arrayOf(
    PropTypes.shape({
      friendlyName: PropTypes.string.isRequired,
      linkUrl: PropTypes.string.isRequired,
      isCurrentCategory: PropTypes.bool
    })
  ).isRequired,
  relatedLinks: PropTypes.arrayOf(
    PropTypes.shape({
      friendlyName: PropTypes.string.isRequired,
      linkUrl: PropTypes.string.isRequired
    })
  )
};
CategoryHeaderLinks.defaultProps = {
  relatedLinks: []
};

export default CategoryHeaderLinks;
